<!-- 首页 -->
<template>
    <div>
        <div v-if="company_name" class="header">
            <div class="header-title">{{ company_name }}</div>
        </div>
        <div class="header pb0">
            <DatePicker
                class="w300 mr24 mb24"
                type="daterange"
                split-panels
                placement="bottom-start"
                placeholder=" 开始时间 至 截止时间 "
                separator=" 至 "
                @on-change="changeDate"
            ></DatePicker>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.product_id"
                clearable
                filterable
                placeholder="选择产品"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.batch_id"
                clearable
                filterable
                placeholder="选择批次"
            >
                <Option
                    v-for="item in batchList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.batch_name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确定搜索</Button
            >
        </div>
        <Row>
            <Col class="card" span="16">
                <div class="echart-title">溯源码查询全国数据统计分析</div>
                <div class="map-div">
                    <div class="map-h">全国各省(直辖市)查询统计</div>
                    <EchartMap
                        v-if="isLoading"
                        id="three"
                        :data="mapData"
                        :min="echartMapData.mapMin"
                        :max="echartMapData.mapMax"
                    ></EchartMap>
                </div>
            </Col>
            <Col class="pl24" span="8">
                <div class="card">
                    <div class="echart-title">查询数量排行</div>
                    <div class="bar-div">
                        <EchartBar
                            v-if="isLoading"
                            id="four"
                            :yValue="fourYValue"
                            :xValue="fourXValue"
                        ></EchartBar>
                    </div>
                </div>
                <div class="card mt12">
                    <div class="echart-title">代理商分布</div>
                    <div class="pie-line-div">
                        <EchartPie
                            v-if="isLoading"
                            id="two"
                            :data="pieData"
                        ></EchartPie>
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col class="card mt24" span="24">
                <div class="echart-title">溯源码查询全国数据统计分析</div>
                <div class="pie-line-div">
                    <EchartLine
                        v-if="isLoading"
                        id="one"
                        :xAxis="oneXAxis"
                        :series="oneSeries"
                    ></EchartLine>
                </div>
            </Col>
        </Row>
        <div class="card mt24 p24">
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="qrcode_number">
                    <div>{{ row.qrcode_number }}</div>
                </template>
                <template slot-scope="{ row }" slot="agent">
                    <div v-if="row.qrcode.length">
                        {{
                            row.qrcode[0].agent
                                ? row.qrcode[0].agent.agent_name
                                : ""
                        }}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product_query_count">
                    <div
                        class="color-53C41A"
                        v-if="row.product_query_count == 1"
                    >
                        首次查询
                    </div>
                    <div v-else>
                        多次查询,已查{{ row.product_query_count }}次
                    </div>
                </template>
                <template slot-scope="{ row }" slot="name">
                    <div class="flex-c">
                        <img
                            class="width_16 mr12"
                            v-if="row.drive == 'ios'"
                            src="@/assets/ios.png"
                        />
                        <img
                            class="width_16 mr12"
                            v-else
                            src="@/assets/android.png"
                        />
                        <div>{{ row.name }}</div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="province">
                    <div v-if="row.address">{{ row.address }}</div>
                    <div v-else>{{ row.province }}{{ row.city }}</div>
                </template>
            </Table>
            <Page
                class="ta-r mt24"
                :current="storePrams.page"
                :page-size="storePrams.limit"
                :total="total"
                show-total
                show-elevator
                @on-change="pageChange"
            />
        </div>
    </div>
</template>
<script>
import {
    home_statistics,
    home_get_count,
    home_query_record,
    product_select,
    batch_select,
} from "@/api/index";
import {
    EchartLine,
    EchartBar,
    EchartPie,
    EchartMap,
} from "@/components/eChart/index";
export default {
    components: { EchartLine, EchartBar, EchartPie, EchartMap },
    data() {
        return {
            echartMapData: {
                mapMin: 0,
                mapMax: 0,
            },
            mapData: [],
            storePrams: {
                page: 1,
                limit: 10,
                product_id: "",
                batch_id: "",
                start_date: "",
                end_date: "",
            },
            total: 0,
            productList: [],
            batchList: [],
            oneSeries: [
                {
                    name: "",
                    type: "line",
                    stack: "总量",
                    data: [],
                    smooth: true,
                    lineStyle: { color: "#FF6161", width: 5 },
                    itemStyle: { color: "#FF6161" },
                    symbolSize: 10,
                },
            ],
            oneXAxis: [],
            fourYValue: [],
            fourXValue: [],
            pieData: [],
            columnsTable: [
                { title: "产品编码", slot: "qrcode_number", align: "center" },
                { title: "所属代理", slot: "agent", align: "center" },
                {
                    title: "查询结果",
                    slot: "product_query_count",
                    align: "center",
                },
                { title: "查询时间", key: "created_at", align: "center" },
                { title: "查询会员", slot: "name", align: "center" },
                { title: "查询人定位信息", slot: "province", align: "center" },
            ],
            dataTable: [],
            company_name: "",
            isLoading: false,
        };
    },
    computed: {
        // 查询数量排行前五
        topFiveItems() {
            // 使用slice创建原数组的浅拷贝，防止直接修改data中的数组
            const sortedItems = this.mapData;
            // 按value属性降序排序
            sortedItems.sort((a, b) => b.value - a.value);
            // 返回前五个元素构成的新数组
            return sortedItems.slice(0, 5);
        },
    },
    mounted() {
        this.getStatistics();
        this.getQueryRecord();
        this.getProductList();
        this.getBatchList();
        this.getCount();
    },
    methods: {
        // echartAPI
        getStatistics() {
            const data = {
                start_date: this.storePrams.start_date,
                end_date: this.storePrams.end_date,
                batch_id: this.storePrams.batch_id,
                product_id: this.storePrams.product_id,
            };
            home_statistics(data).then((res) => {
                this.pieData = res.data.agent_province;
                this.mapData = res.data.list;
                const topFiveItems = this.topFiveItems;
                const reversedTopFiveItems = [...topFiveItems].reverse();
                reversedTopFiveItems.forEach((item) => {
                    this.fourYValue.push(item.name);
                    this.fourXValue.push(item.value);
                });
                this.echartMapData.mapMin = res.data.min;
                this.echartMapData.mapMax = res.data.max;
                // line
                const oneXAxis = res.data.line;
                oneXAxis.forEach((item) => {
                    this.oneXAxis.push(item[0]);
                    this.oneSeries[0].data.push(item[1]);
                });
                this.isLoading = true;
            });
        },
        // 公司名，短信数量
        getCount() {
            home_get_count().then((res) => {
                this.company_name = res.data.company
                    ? res.data.company.company_name
                    : "";
            });
        },
        // 产品下拉列表
        getProductList() {
            product_select().then((res) => {
                this.productList = res.data;
            });
        },
        // 批次下拉列表
        getBatchList() {
            batch_select().then((res) => {
                this.batchList = res.data;
            });
        },
        changeDate(e) {
            if (e[0]) {
                this.storePrams.start_date = e[0];
                this.storePrams.end_date = e[1];
            } else {
                this.storePrams.start_date = "";
                this.storePrams.end_date = "";
            }
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getQueryRecord();
        },
        goSearch() {
            this.getStatistics();
            this.storePrams.page = 1;
            this.getQueryRecord();
        },
        getQueryRecord() {
            home_query_record(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
    },
};
</script>

<style scoped>
.header {
    padding: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.header-title {
    margin-right: 48px;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
}
.header-title:before {
    margin-right: 5px;
    content: "";
    display: inline-block;
    width: 3px;
    height: 16px;
    background: #ff761d;
    border-radius: 5px;
}
.echart-title {
    padding: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
    border-bottom: 1px solid #f5f6fa;
}
.pb0 {
    padding-bottom: 0 !important;
}
.pl24 {
    padding-left: 24px;
}
.map-div {
    margin: auto;
    width: 90%;
    height: 680px;
    text-align: center;
}
.map-h {
    margin: 12px 0;
    font-weight: bold;
    font-size: 18px;
    color: #484e66;
}
.bar-div {
    width: 90%;
    height: 300px;
}
.pie-line-div {
    width: 90%;
    height: 400px;
}
.p24 {
    padding: 24px;
}
.color-53C41A {
    color: #53c41a;
}
.card {
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    background-color: #fff;
    border-radius: 4px;
}
.ta-r {
    text-align: right;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>